import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '@config';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class InternalReleaseNotesService {

    constructor(private http: HttpClient, private config: Config) {}

    public get(): Promise<any> {
        const options = {
            contentType: 'json',
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return lastValueFrom(this.http.get(this.config.services.internalReleaseNotes.all, options));
    }
}
